<template>
  <div class="dash-body" @click="clickBody()">
    <template v-if="currModule == 'home' || currModule === 'profileimg'">
      <div class="content-wrapper">
        <section class="content">
          <router-view />
        </section>
      </div>
    </template>
    <template v-else>
      <div class="content-wrapper">
        <section class="content-header">
          <widget-breadcrumb
            :fontIcon="fontIcon"
            :currModule="currModule"
            :currCodapp="currCodapp"
            :nameModule="nameModule"
            :descCodapp="descCodapp"
            :codapp="codapp"
            :descModule="descModule" />
        </section>
        <div class="clearfix"></div>
        <section class="content">
          <widget-license-flash-message />
          <widget-flash-message />
          <router-view />
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import WidgetLicenseFlashMessage from 'components/dash/widgets/WidgetLicenseFlashMessage'
import WidgetFlashMessage from 'components/dash/widgets/WidgetFlashMessage'
import WidgetBreadcrumb from 'components/dash/widgets/WidgetBreadcrumb'

export default {
  name: 'dash-body',
  props: [ 'fontIcon', 'currModule', 'currCodapp', 'nameModule', 'descCodapp', 'codapp', 'descModule', 'closeControlsidebar', 'controlsidebarDisp', 'pcDisp', 'closeSidebarMobile' ],
  methods: {
    clickBody () {
      this.closeControlsidebar(this.controlsidebarDisp)
      this.closeSidebarMobile()
    }
  },
  components: {
    WidgetLicenseFlashMessage,
    WidgetFlashMessage,
    WidgetBreadcrumb
  }
}
</script>

<style lang="scss">
@media (min-width: 768px) {
  .dash-body{
    .content {
      min-height: 90vh !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// DashBody.vue?47ef3e8d